/**
 * 全局过滤器
 * @Description: 包括时间格式化、字符串格式化、金额格式化等
 *
 * @Author: JZT.Oscar
 * @Date: 2018-10-04 14:31:05
 * @Last Modified by: JZT.Oscar
 * @Last Modified time: 2018-10-16 17:48:31
 */

import { getCurrentServiceDomain } from "./common";
import { formatDate } from "./utils";

// 将接口请求路径自适应环境
// 本地使用代理时，使用相对根路径
// 发布到服务器时，是用完整url路径
const API = function(path) {
    if (process.env.NODE_ENV === "production") {
        return getCurrentServiceDomain() + path;
    }
    return path;
};
// 将路径添加二级目录
const baseRoot = function(path) {
    return `/sass/${path}`;
    // return `/admin/${path}`;
};

const formatUrl=function(urlValue){
      if(typeof urlValue=="string"){
        let url=urlValue.trim();
        if(/^http(s)?:\/\//.test(url)===true||/^\//.test(url)===true||/^#/.test(url)===true){
            return url;
        }else{
            return "http://"+url;
        }
      }else{
          return "";
      }
}

export default { API, formatDate, baseRoot,formatUrl };



// WEBPACK FOOTER //
// ./src/libs/filters.js